import { LayoutCreditNote } from './Layout/LayoutCreditNote'
export const CreditNoteScreen = () => {
  return (
    <LayoutCreditNote />
  )
}
